import ajax from './axios'

export const getChart = (params) => {
    return ajax.get('/api/v2/hotkeyword/fund/hotspot_data_network_visualization', params)
}

export const getTrendsData = (params) => {
    return ajax.get('/api/v2/trends/keyword', params)
}


// WEBPACK FOOTER //
// ./src/api/hotKeywordsMap.js